import { z } from 'zod';

import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const BaseUpsertTransactionSideEffect = BaseLoanIdSideEffect.extend({
  incrementChangeId: z.boolean().prefault(true).optional(),
});
